import React, { useContext } from 'react';
import { useTPAComponentsContext } from 'wix-ui-tpa/cssVars';
import { faqButtonClickSrc63Evid836 } from '@wix/bi-logger-labs-data/v2';
import { useBi, useEnvironment } from '@wix/yoshi-flow-editor';
import type { Category } from '@wix/ambassador-faq-category-v2-category/types';
import VerticalTabs from './VerticalCategories';
import HorizontalCategories from './HorizontalCategories';
import { useCategories } from '../../../../hooks/useCategories';
import { AppContext } from '../SettingsProvider/SettingsProvider';
import { TabItem } from 'wix-ui-tpa';

export interface TabsWrapperProps {
  validLists: Category[];
}

const TabsWrapper = ({ validLists }: TabsWrapperProps) => {
  const logger = useBi();
  const { appDefinitionId } = useEnvironment();
  const { setFirstQuestionId, searchTerm, fetchError, baseURL } =
    useContext(AppContext);
  const { rtl, seo } = useTPAComponentsContext();

  const {
    categoriesToRender,
    activeTab,
    setActiveTab,
    splitIntoCategories,
    topCategoriesPosition,
    sideCategoriesPosition,
  } = useCategories(validLists);

  const handleTabClick = (index: number) => {
    setActiveTab(index);
    setFirstQuestionId?.(undefined);
    const category = categoriesToRender[index];
    logger.report(
      faqButtonClickSrc63Evid836({
        button_name: category?.id || category?.title || `${index}`,
        action: 'tab',
      }),
    );
  };

  const isDisplayCategories =
    !searchTerm && splitIntoCategories && categoriesToRender.length > 0;

  if (fetchError) {
    return null;
  }
  let categoriesWithLink = categoriesToRender;
  if (seo) {
    categoriesWithLink = categoriesToRender.map((category) => {
      const categoryURL = new URL(baseURL);
      categoryURL.searchParams.set('categoryId', `${category.id}`);
      categoryURL.searchParams.set('appDefId', appDefinitionId);
      return {
        ...category,
        href: categoryURL,
      };
    });
  }
  return (
    <>
      {isDisplayCategories && topCategoriesPosition && (
        <HorizontalCategories
          categoriesToRender={categoriesWithLink as TabItem[]}
          adjustedActiveTab={activeTab}
          setActiveTab={handleTabClick}
          splitIntoCategories={splitIntoCategories}
          rtl={rtl || false}
        />
      )}
      {isDisplayCategories && sideCategoriesPosition && (
        <VerticalTabs
          sideCategoriesPosition={sideCategoriesPosition}
          categoriesToRender={categoriesWithLink as TabItem[]}
          activeTab={activeTab}
          setActiveTab={handleTabClick}
        />
      )}
    </>
  );
};

export default TabsWrapper;
